import React from "react";
import { Link } from "react-router-dom";
import { brl, fmtDate } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { ArrowRight, Calendar, Users } from "lucide-react";

export default function RaffleCard({ raffle }) {
  const pct = Math.min(100, Math.round((raffle.sold_quotas / raffle.total_quotas) * 100));
  const img = raffle.images?.[0];
  const imgSrc = img?.startsWith("http") ? img : img ? `${process.env.REACT_APP_BACKEND_URL}${img}` : null;

  return (
    <Link
      to={`/rifa/${raffle.raffle_id}`}
      data-testid={`raffle-card-${raffle.raffle_id}`}
      className="card-luxury rounded-2xl overflow-hidden group flex flex-col"
    >
      <div className="relative aspect-[16/10] overflow-hidden">
        {imgSrc ? (
          <img src={imgSrc} alt={raffle.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-slate-800 to-slate-900" />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-transparent to-transparent" />
        <div className="absolute top-3 left-3 flex gap-2">
          <Badge className="bg-slate-950/80 backdrop-blur border border-amber-500/30 text-amber-200 uppercase tracking-widest text-[10px]">
            {raffle.category || "LUXO"}
          </Badge>
          {raffle.status === "drawn" && (
            <Badge className="bg-emerald-500/20 border border-emerald-400/40 text-emerald-200 uppercase tracking-widest text-[10px]">
              Sorteada
            </Badge>
          )}
        </div>
        <div className="absolute bottom-3 right-3">
          <div className="glass rounded-full px-3 py-1 text-xs font-mono text-amber-200">
            {brl(raffle.quota_price)} / cota
          </div>
        </div>
      </div>

      <div className="p-5 flex flex-col gap-4 flex-1">
        <div>
          <h3 className="heading text-lg font-bold text-slate-50 leading-tight line-clamp-1">{raffle.title}</h3>
          <p className="text-sm text-slate-400 mt-1 line-clamp-2">{raffle.description}</p>
        </div>

        <div>
          <div className="flex justify-between text-xs text-slate-400 mb-1.5 font-mono">
            <span>{pct}% vendido</span>
            <span>{raffle.sold_quotas?.toLocaleString('pt-BR')} / {raffle.total_quotas?.toLocaleString('pt-BR')}</span>
          </div>
          <div className="progress-bar-track">
            <div className="progress-bar-fill" style={{ width: `${pct}%` }} />
          </div>
        </div>

        <div className="flex items-center justify-between text-xs text-slate-400 mt-auto">
          <div className="flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5 text-amber-300" /> {fmtDate(raffle.draw_date)}</div>
          <div className="flex items-center gap-1.5"><Users className="w-3.5 h-3.5 text-emerald-300" /> {raffle.sold_quotas?.toLocaleString('pt-BR')}</div>
        </div>

        <div className="flex items-center justify-between pt-3 border-t border-white/5">
          <span className="text-xs uppercase tracking-widest text-slate-500">Prêmio</span>
          <span className="heading font-bold gold-gradient-text">{brl(raffle.prize_value)}</span>
        </div>

        <div className="gold-btn rounded-full py-2 text-center text-sm inline-flex items-center justify-center gap-2 group-hover:brightness-110">
          Comprar Cotas <ArrowRight className="w-4 h-4" />
        </div>
      </div>
    </Link>
  );
}
